import React from "react";
import { Typography } from "material-ui";
import { formatDateTimeString } from "./../../../utilities/datesFormatter";
import TileIcon from "./TileIcon";
import PowerIcon from "material-ui-icons/PowerSettingsNew";

const fakeData = {
  Fecha: "2018-08-29T00:46:16",
  Unidad: "TRA 01",
  Cuenta: "Cuenta de Juan Perez "
};

const ApagadosMotorTile = props => {
  const { data } = props;
  const dateTime = formatDateTimeString(fakeData.Fecha);
  return (
    <div className="dashboard-tile">
      <TileIcon color="#f86262" icon={PowerIcon} />
      <div className="tile-header">Último apagado de motor</div>
      <div className="tile-body">
        <Typography
          variant="display1"
          align="center"
          color="textSecondary"
          className="headline"
        >
          <span>{dateTime[0]}</span>
        </Typography>
        <Typography
          variant="title"
          align="center"
          color="textSecondary"
          className="headline"
        >
          <span>{dateTime[1]}</span>
        </Typography>
      </div>
      <div className="tile-footer">
        <Typography
          variant="title"
          align="center"
          color="primary"
          className="headline"
        >
          <span>{fakeData.Unidad}</span>
        </Typography>
        <Typography
          variant="subheading"
          align="center"
          color="textSecondary"
          className="headline"
        >
          <span>{fakeData.Cuenta}</span>
        </Typography>
      </div>
    </div>
  );
};

export default ApagadosMotorTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/ApagadosMotorTile.js